import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { XSMALL_BREAKPOINT } from '../../../../style'

export const Wrapper = styled.div`
  width: 100%;
  background: white;
  padding: 10rem 0;
  filter: drop-shadow(0 2px 48px rgba(0, 0, 0, 0.1));
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    padding: 1.25rem;
    height: auto;
  }
`
export const OrdersButton = styled.button`
  background: ${colors.adaptBlue};
  border-radius: 6.25rem;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  border: 0;
  height: 2.75rem;
  padding: 0 1.6rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    width: 12.5rem;
  }
`
export const InnerWrapper = styled.div`
  display: flex;
  max-width: 44rem;

  p {
    margin-bottom: 16px;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
    text-align: center;
    max-width: 15rem;

    div {
      text-align: center;
    }
    h3 {
      font-size: 1.25rem;
      line-height: 1.75rem;
      text-align: center;
    }
    p {
      font-size: 1rem;
      line-height: 1.6rem;
      text-align: center;
      margin-bottom: 24px;
    }
  }

  picture {
    margin-right: 1.5rem;
    flex: 1 0 12.5rem;

    img {
      width: 12.5rem;
      max-width: 100%;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/NoOrders/NoOrders.style.tsx